import { useEffect, useState } from 'react';
import { useI18n } from 'src/utils/lni18n';
import { CoursePartWithConnectedDTO } from '../domain/GetCoursepartsResponse';

import classes from "../CoursePart.module.scss";
import { IdAndNameAndSelectDto, IdAndNameDto } from 'src/types';
import { useAtom } from 'jotai';
import coursePartService, { authorsAtom } from '../CoursePartService';
import { Typeahead } from 'react-bootstrap-typeahead';


const CoursePartFindByAuthor = (props: { itemChosen: (item: CoursePartWithConnectedDTO) => void }) => {

    const { itemChosen } = props;
    const { languageService: t } = useI18n();
    const [selected, setSelected] = useState<IdAndNameAndSelectDto>();

    const [items, setItems] = useState<IdAndNameAndSelectDto[]>([]);
    const [selectedAuthor, setSelectedAuthor] = useState<IdAndNameDto | undefined>();
    const [loadingAuthor, setLoadingAuthor] = useState<boolean>(false);

    const [authors] = useAtom(authorsAtom);

   
    const setSelectedItem = (item: IdAndNameAndSelectDto) => {
        setSelected(item);
        setItems(ps => ps.map(p => { return { ...p, Selected: p.Id === item.Id } }));
    }

    const authorSelected = async (e: any) => {

        setSelected(undefined);

        if (!(e && e.length > 0 && e[0].Id)) {
            setItems([]);
            setSelectedAuthor(undefined);
            return;

        }

        const id = e[0].Id;


        const author = authors.find(a => a.Id === id);
        setSelectedAuthor(author);
        setItems([]);
        setLoadingAuthor(true);
        try {
            const parts = await coursePartService.getPartsByAuthor(id);
            setItems(parts || []);
        }
        finally {
            setLoadingAuthor(false);
        }

    }


    return <>
        <div className='d-flex align-items-center'>

            <Typeahead
                id="authors-select"
                labelKey="Name"
                minLength={1}
                multiple={false}
                onChange={authorSelected}
                options={authors}
                placeholder={t.getText("name")}
                dropup={true}
                positionFixed={true}
                className='w-100'
            />

            <button disabled={!selected} onClick={() => itemChosen(selected! as CoursePartWithConnectedDTO)} className="ml-5 btn btn-primary">{t.getText("add")}</button>

        </div>

        {!loadingAuthor && selectedAuthor && 
            <div className={`mt-3 ${classes.coursePartList}`} aria-live="polite">


                {items.map(p =>
                    <button key={p.Id} title={`${t.getText("coursepart")} ${p.Name}`} onClick={() => setSelectedItem(p)} className={`${p.Selected ? "selected" : ""} px-2 pb-1 text-left btn btn-link`}>{p.Name}</button>)
                }

            </div>
        }
    </>
}


export default CoursePartFindByAuthor;